let popupClosedAt = null;
const { setCookie, checkCookie } = window.CookieClass;
const selectors = {
  timeoutPopup: '#timeoutPopup',
  exitpopup: '#exitPopup',
  popupClose: '[data-close-popup]',
  form: '[data-newsletter-form]',
  firstStep: '[data-first-step]',
  secondStep: '[data-second-step]',
  copyBtn: '[data-copy]',
  copyBtnInput: '[data-copy-input]',
  copyBtnTooltip: '[data-tooltip]'
};

const copyBtnInput = document.querySelector(selectors.copyBtnInput);
const COOKIE_NAME = `popup-subscribed-${copyBtnInput?.value || 'default'}`;
const EXIT_COOKIE_NAME = `popup-exit-closed-${copyBtnInput?.value || 'default'}`;
const CLOSED_COOKIE_NAME = `popup-closed-${copyBtnInput?.value || 'default'}`;
let exitPopupShown = false;

function showPopup(id) {
  const popup = document.querySelector(id);
  if (popup) {
    popup.classList.add('open');
    document.body.classList.add('overflow-hidden');
  }
}

function closePopup(id) {
  const popup = document.querySelector(id);
  if (!popup) return;
  popup.classList.remove('open');
  document.body.classList.remove('overflow-hidden');
  popupClosedAt = Date.now();
  if (id === selectors.exitpopup) {
    setCookie(EXIT_COOKIE_NAME, 'true', 180);
  }
  if (id === selectors.timeoutPopup) {
    setCookie(CLOSED_COOKIE_NAME, 'true', 1);
  }
}

function sendToKlaviyo(email, code) {
  if (window._klOnsite && Array.isArray(window._klOnsite)) {
    window._klOnsite.push(["identify", {
      email: email,
      discount_code: code,
      discount_code_expiry: "7 days",
      "popup-subscriber": true
    }]);
    setCookie(COOKIE_NAME, 'true', 180);
  } else {
    console.error("Klaviyo not ready yet");
  }
}

async function handleFormSubmit(formId, popupId, successMessage) {
  const form = document.getElementById(formId);
  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const email = form.querySelector('input[type="email"]').value;
    const errorEl = form.querySelector('[data-error-msg]');
    if (errorEl) errorEl.textContent = '';

    try {
      const res = await fetch(`https://bester-promo-worker.vanzonice7777.workers.dev/?email=${encodeURIComponent(email)}`);
      if (!res.ok) throw new Error("API error: " + await res.text());
      const data = await res.json();
      if (data.exists) {
        if (errorEl) errorEl.textContent = 'You are already subscribed!';
        return;
      }
      const code = data.code;
      if (!code) throw new Error("No promo code");

      sendToKlaviyo(email, code);
      document.querySelector(`${popupId} ${selectors.firstStep}`).classList.add('hidden');
      document.querySelector(`${popupId} ${selectors.secondStep}`).classList.remove('hidden');
    } catch (err) {
      console.error("Form error:", err);
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (!checkCookie(COOKIE_NAME) && !checkCookie(CLOSED_COOKIE_NAME)) {
    setTimeout(() => showPopup(selectors.timeoutPopup), 10000);
  }

  handleFormSubmit("popup__form-main", selectors.timeoutPopup, "Thank you! Your code will be sent by email.");
  handleFormSubmit("popup__form-exit", selectors.exitpopup, "Your code will be sent by email!");

  document.addEventListener("mouseleave", () => {
     console.log(popupClosedAt, "Hover");
    if (!exitPopupShown && !checkCookie(COOKIE_NAME) && popupClosedAt && Date.now() - popupClosedAt > 20000) {
      showPopup(selectors.exitpopup);
      exitPopupShown = true;
      setCookie(EXIT_COOKIE_NAME, 'true', 180);
    }
  });

  // Show exit popup only on mobile when tab is hidden after timeout
  document.addEventListener("visibilitychange", () => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if (
      isMobile &&
      document.visibilityState === "hidden" &&
      !exitPopupShown &&
      !checkCookie(COOKIE_NAME) &&
      popupClosedAt &&
      Date.now() - popupClosedAt > 20000
    ) {
      showPopup(selectors.exitpopup);
      exitPopupShown = true;
      setCookie(EXIT_COOKIE_NAME, 'true', 180);
    }
  });

  document.addEventListener('click', (e) => {
    const isClose = e.target.closest(selectors.popupClose);
    const isBgMain = e.target === document.querySelector(selectors.timeoutPopup);
    const isBgExit = e.target === document.querySelector(selectors.exitpopup);

    if (isClose || isBgMain) closePopup(selectors.timeoutPopup);
    if (isClose || isBgExit) closePopup(selectors.exitpopup);
  });
});
